import { useTheme } from "@mui/material";
import {
	BarChart3,
	Calculator,
	IdCard,
	ListTodo,
	Settings,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
	type FinancesNavigationState,
	FinancesOrigin,
} from "web_myplann/Finances/Types/FinancesNavigationState";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import type { SettingsMenuItemType } from "web_myplann/More/Types/SettingsMenuItemType";
import { device, NavigationTypes } from "web_myplann/Utils/device";

export const useSettingsMenuItems = () => {
	const theme = useTheme();
	const { t } = useResource();
	const navigate = useNavigate();

	const toolItems: SettingsMenuItemType[] = [
		{
			id: "financial-balance",
			icon: BarChart3,
			label: t(Resources.Settings.Items.FinancialBalance),
			iconBg: theme.palette.green[100],
			iconColor: theme.palette.green[600],
			onClick: () =>
				navigate(AppRouting.MyPlann.Finances.Intro.path(), {
					state: {
						from: FinancesOrigin.Profile,
					} satisfies FinancesNavigationState,
				}),
		},
		{
			id: "my-documents",
			icon: IdCard,
			label: t(Resources.Settings.Items.MyDocuments),
			iconBg: theme.palette.indigo[100],
			iconColor: theme.palette.indigo[600],
			onClick: () => navigate(AppRouting.MyPlann.Profile.Paperwork.path()),
		},
		{
			id: "activities",
			icon: ListTodo,
			label: t(Resources.Settings.Items.Activities),
			iconBg: theme.palette.orange[100],
			iconColor: theme.palette.orange[600],
			onClick: () => navigate(Routing.ActivitiesList.path()),
		},
		{
			id: "calculators",
			icon: Calculator,
			label: t(Resources.Settings.Items.Calculators),
			iconBg: theme.palette.purple[100],
			iconColor: theme.palette.purple[600],
			onClick: () =>
				device.navigationRequest(NavigationTypes.CalculatorListScreen),
		},
	];

	const settingsItems: SettingsMenuItemType[] = [
		{
			id: "settings",
			icon: Settings,
			label: t(Resources.Settings.Items.Settings),
			iconBg: theme.palette.grey[100],
			iconColor: theme.palette.grey[600],
			onClick: () => navigate(AppRouting.MyPlann.Profile.Settings.path()),
		},
	];

	return { toolItems, settingsItems };
};
